module.exports = __webpack_public_path__ + "img/mobile/BetBar-freespins/fs-spins-bg@2x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/BetBar-freespins/fs-spins-bg@2x.png
// module id = 182
// module chunks = 0